import { configureStore } from '@reduxjs/toolkit';
import notificationsReducer from 'hooks/notificationsSlice';
import markersReducer from 'hooks/markersSlice';
import routesReducer from 'hooks/routesSlice';
import reportsReducer from 'hooks/reportsSlice';
import areasReducer from 'hooks/areasSlice';
import editReducer from 'hooks/editSlice';

export const store = configureStore({
  reducer: {
    notifications: notificationsReducer,
    routes: routesReducer,
    markers: markersReducer,
    reports: reportsReducer,
    areas: areasReducer,
    edit: editReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
